/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

  // Add custom code below this line

(function() {

  document.addEventListener('DOMContentLoaded', function() {

    var description = document.querySelector('.product__description');
    if (!description) return;

    var imperial = description.querySelector('[data-unit-system="imperial"]');
    var metric = description.querySelector('[data-unit-system="metric"]');

    if (imperial) imperial.style.display = 'none';
    if (metric) metric.style.display = 'none';

    if (!imperial && !metric) return;

    var sizeLegend = null;
    document.querySelectorAll('legend.radio__legend').forEach(function(l) {
      if (l.textContent.trim().toLowerCase().includes('size')) sizeLegend = l;
    });

    if (!sizeLegend) return;

    var fieldset = sizeLegend.closest('fieldset');
    if (!fieldset) return;

    var link = document.createElement('button');
    link.textContent = '📏 Size Guide';
    link.className = 'size-chart-link';
    link.type = 'button';
    sizeLegend.appendChild(link);

    var modal = document.createElement('div');
    modal.className = 'size-chart-modal';
    modal.innerHTML = '<div class="size-chart-modal__inner"><button type="button" class="size-chart-modal__close">✕</button><div class="size-chart-modal__content"></div></div>';
    document.body.appendChild(modal);

    var content = modal.querySelector('.size-chart-modal__content');

    if (imperial && metric) {
      var toggle = document.createElement('div');
      toggle.className = 'size-chart-toggle';
      toggle.innerHTML = '<button type="button" class="active" data-unit="imperial">IN</button><button type="button" data-unit="metric">CM</button>';
      content.appendChild(toggle);

      var impClone = imperial.cloneNode(true);
      var metClone = metric.cloneNode(true);
      impClone.style.display = 'block';
      metClone.style.display = 'none';
      content.appendChild(impClone);
      content.appendChild(metClone);

      toggle.addEventListener('click', function(e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        toggle.querySelectorAll('button').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        impClone.style.display = btn.dataset.unit === 'imperial' ? 'block' : 'none';
        metClone.style.display = btn.dataset.unit === 'metric' ? 'block' : 'none';
      });
    } else {
      var onlyClone = (imperial || metric).cloneNode(true);
      onlyClone.style.display = 'block';
      content.appendChild(onlyClone);
    }

    link.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      modal.classList.add('active');
    });

    modal.querySelector('.size-chart-modal__close').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      modal.classList.remove('active');
    });

    modal.addEventListener('click', function(e) {
      if (e.target === modal) modal.classList.remove('active');
    });

    fieldset.addEventListener('click', function(e) {
      e.stopPropagation();
    });

  });

})();




// ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
